module.exports = __webpack_public_path__ + "img/img2.37451fc5.jpg";